import type {
  TChatAnswerDonePayload,
  TErrorPayload,
} from '@cascade/api-client/events';
import type { TMessageInfo } from '@cascade/api-client/ge-v2';
import type { TMessage } from '#providers/conversations/index.ts';
import { getMessageKey } from '#providers/experiences/Experience.helpers.ts';

export const interruptedAnswer: TErrorPayload = {
  code: 'INTERNAL_ERROR',
  message: 'The answer stopped before it completed',
};

export const toStoredMessages = (
  stored: TMessageInfo[] = [],
  requestMessages: TMessage[] = [],
): TMessage[] => {
  const requestMessageIds = requestMessages.flatMap(({ id, requestId }) => [
    id,
    requestId,
  ]);

  const shownIds = new Set(requestMessageIds);
  const unshownMessages = stored.filter(
    (info) => !shownIds.has(info.message_id),
  );

  return unshownMessages.map((info) => {
    const id = getMessageKey(info);

    return {
      id,
      key: id,
      sender: info.sender,
      message: info.message_text,
      date: info.timestamp,
      status: 'complete',
    };
  });
};

export const toMessageInfos = (
  question: string,
  { answer, message_id: messageId }: TChatAnswerDonePayload,
  requestId: string,
): TMessageInfo[] => {
  const storedId = messageId ?? requestId;

  return [
    { message_id: storedId, message_text: question, sender: 'user' },
    { message_id: storedId, message_text: answer, sender: 'bot' },
  ];
};
